// Calm transition band: a soft glow + slim gradient line with three gently
// drifting colour dots pinned at ±150px from centre. Purely decorative.
//
// Dots are centred on the line via a `top` calc offset (half the dot height)
// rather than a transform, so the `sep-drift` animation's transform — which
// resets to translateY(0) — is free to handle the vertical drift without
// knocking the dots off the line.
interface Props {
  /** Render the slim dividing line behind the dots (on by default). */
  showLine?: boolean;
}

export const Separator1 = ({ showLine = true }: Props = {}) => (
  <div className={styles.band} aria-hidden="true">
    <span className={styles.glow} />
    {showLine && <span className={styles.line} />}
    <span
      className={`${styles.dot} left-[calc(50%-150px)] top-[calc(50%-2.5px)] bg-[#FDE47A] shadow-[0_0_11px_rgba(247,203,45,0.7)] motion-safe:animate-sep-drift`}
    />
    <span className="absolute left-1/2 top-[calc(50%-3.5px)] h-[7px] w-[7px] rounded-full bg-[#7fa8ff] shadow-[0_0_12px_rgba(127,168,255,0.8)] motion-safe:animate-sep-drift [animation-delay:0.4s]" />
    <span
      className={`${styles.dot} left-[calc(50%+150px)] top-[calc(50%-2.5px)] bg-[#6ed7a6] shadow-[0_0_11px_rgba(110,215,166,0.85)] motion-safe:animate-sep-drift [animation-delay:0.8s]`}
    />
  </div>
);

const styles = {
  band: 'relative flex h-[200px] items-center justify-center overflow-hidden marketing-dark:bg-mf-navy',
  glow: [
    'pointer-events-none absolute h-[150px] w-[540px] max-w-full blur-[6px] motion-safe:animate-sep-pulse',
    '[background:radial-gradient(60%_60%_at_50%_50%,rgba(189,222,255,0.5),transparent_72%)]',
    'marketing-dark:[background:radial-gradient(60%_60%_at_50%_50%,rgba(127,168,255,0.16),transparent_72%)]',
  ].join(' '),
  line: [
    'pointer-events-none absolute h-px w-[min(620px,76%)]',
    '[background:linear-gradient(90deg,transparent,rgba(39,87,186,0.35),transparent)]',
    'marketing-dark:[background:linear-gradient(90deg,transparent,rgba(127,168,255,0.5),transparent)]',
  ].join(' '),
  dot: 'absolute h-[5px] w-[5px] rounded-full',
};
